import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-onboarding-steps-pagination',
  templateUrl: './onboarding-steps-pagination.component.html',
  styleUrl: './onboarding-steps-pagination.component.scss',
  standalone: false,
})
export class OnboardingStepsPaginationComponent {
  @Input() activeIndex = 0;

  onActiveIndexChange(event: number) {
    this.activeIndex = event;
  }

  MenuItem = [
    {
      label: 'Create Workspace',
      command: (event: any) => {
        this.activeIndex = 0;
      },
    },
    {
      label: 'Connect Social Accounts',
      command: (event: any) => {
        this.activeIndex = 1;
      },
    },
  ];
}
